/**
 * Extracts the last segment of a given URL path after the last "/".
 * If the URL does not contain any segments, the original URL is returned.
 *
 * @param {string} url - The input URL from which to extract the last segment.
 * @returns {string} - The last segment of the URL or the original URL if no segment is found.
 */
export const extractLastSegment = (url: string): string => {
  const regex = /([^/]+)$/
  const match = url.match(regex)

  if (match && match[1]) {
    return match[1]
  }
  return url
}

export default extractLastSegment
